/**
 * voucherRoute — maps a human-readable voucher_type (as stored in the stock
 * ledger and GL entry, e.g. "Stock Entry", "Work Order") to the detail-page
 * route for that document. Used to turn "Source document" cells in the
 * warehouse movements table and the General Ledger report into real links.
 *
 * Types with no dedicated detail route — POS Invoice, Payroll Entry,
 * Depreciation, and Work Order (the reman `work_order` doctype has a
 * read-only list surface but no per-record detail page) — are omitted — callers should render plain text
 * when voucherHref returns null (no dead links).
 */
const VOUCHER_TYPE_PATH: Record<string, string> = {
  'Stock Entry':      '/stock/stock-entries',
  'Purchase Receipt': '/stock/purchase-receipts',
  'Sales Invoice':    '/accounting/sales-invoices',
  'Purchase Invoice': '/accounting/purchase-invoices',
  'Payment Entry':    '/accounting/payment-entries',
  'Journal Entry':    '/accounting/journal-entries',
  'Delivery Note':    '/accounting/delivery-notes',
};

/** Build a detail-page href for a voucher, or null when it can't be linked. */
export function voucherHref(voucherType?: string, voucherID?: string): string | null {
  if (!voucherType || !voucherID) return null;
  const base = VOUCHER_TYPE_PATH[voucherType];
  return base ? `${base}/${voucherID}` : null;
}
